import React from "react";

const DropdownMenu = ({ label, options, selectedValue, onChange, isActive, className, onMouseOver, onMouseOut }) => (
    <select
        onChange={onChange}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        value={selectedValue}
        className={`${className}${isActive ? " active" : ""}`}
    >
        <option value="" disabled>{label}</option>
        {options.map(({ value, label }) => (
            <option key={value} value={value}>
                {label}
            </option>
        ))}
    </select>
);

export default DropdownMenu;
